/* ============================================================
   AXION // SPECIFICATION — interactive blueprint reveal
   Thin choreographer over the engine-generated overlay SVG.
   No geometry logic here: the SVG is correct by construction;
   this only reveals it and lights one relation at a time.
   ============================================================ */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.__abReady) return; root.__abReady = true;
    var svg = root.querySelector('.ab-overlay svg');
    var legend = root.querySelector('.ab-legend');
    var toggle = root.querySelector('.ab-toggle');
    var dataEl = root.querySelector('.ab-data');
    if (!svg) return;

    var relations = [];
    try { relations = JSON.parse(dataEl.textContent).relations || []; } catch (e) {}

    // stagger index for the draw-on reveal (CSS uses --i; survives bg tabs)
    var groups = svg.querySelectorAll('g[data-id]');
    groups.forEach(function (g, i) { g.style.setProperty('--i', i); });

    var pinned = null;
    function clear() {
      root.classList.remove('ab--focus');
      groups.forEach(function (g) { g.classList.remove('ab-active'); });
      if (legend) legend.querySelectorAll('.ab-chip').forEach(function (c) { c.setAttribute('aria-current', 'false'); });
    }
    function activate(id, chip) {
      var g = svg.querySelector('g[data-id="' + id + '"]'); if (!g) return;
      root.classList.add('ab--focus');
      groups.forEach(function (x) { x.classList.remove('ab-active'); });
      g.classList.add('ab-active');
      if (legend) legend.querySelectorAll('.ab-chip').forEach(function (c) { c.setAttribute('aria-current', 'false'); });
      if (chip) chip.setAttribute('aria-current', 'true');
    }

    // build legend from relations that actually drew a group
    if (legend) {
      relations.forEach(function (r, i) {
        var id = 'r' + i;
        if (!svg.querySelector('g[data-id="' + id + '"]')) return;        // type-scale/texture have no group
        var chip = document.createElement('button');
        chip.type = 'button'; chip.className = 'ab-chip'; chip.setAttribute('aria-current', 'false');
        chip.dataset.target = id;
        chip.innerHTML = '<span class="ab-dot"></span><span class="ab-l">' +
          (r.label || r.kind) + '</span><span class="ab-k">' + (r.kind || '') + '</span>';
        chip.addEventListener('mouseenter', function () { if (!pinned) activate(id, chip); });
        chip.addEventListener('focus', function () { activate(id, chip); });
        chip.addEventListener('mouseleave', function () { if (!pinned) clear(); });
        chip.addEventListener('click', function () {
          if (pinned === id) { pinned = null; clear(); }
          else { pinned = id; activate(id, chip); }
        });
        legend.appendChild(chip);
      });
    }
    if (legend && !legend.querySelector('.ab-count')) {
      var c = document.createElement('div');
      c.className = 'ab-count';
      c.textContent = (svg.querySelectorAll('g[data-id]').length) + ' RELATIONS · CORRECT BY CONSTRUCTION';
      legend.parentNode.appendChild(c);
    }

    function setOn(on) {
      root.classList.toggle('ab--on', on);
      if (!on) { pinned = null; clear(); }
      if (toggle) {
        toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
        var t = toggle.querySelector('.ab-t'); if (t) t.textContent = on ? 'Rendered' : 'Blueprint';
      }
    }
    if (toggle) toggle.addEventListener('click', function () { setOn(!root.classList.contains('ab--on')); });

    // auto-reveal once when scrolled into view (cinematic), unless reduced
    // motion or data-no-auto (e.g. the hero, which stays clean until clicked)
    if (!REDUCED && !root.hasAttribute('data-no-auto') && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && !root.classList.contains('ab--on') && !root.__abAuto) {
            root.__abAuto = true; setOn(true); io.disconnect();
          }
        });
      }, { threshold: 0.45 });
      io.observe(root);
    }
  }

  function boot() { document.querySelectorAll('.ab').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
